import ComingSoon from "./comingsoon";
function MeetTheChef() {
  return (
    <>
      <ComingSoon />
    </>
  );
}

export default MeetTheChef;